<template lang="html">
  <div class="headerNav">
    <div class="introduce">
      <div>
        <img src="../assets/image/DClogo.png" class="logo">
      </div>
      <div class="product">
        <p class="productName">电巢APP</p>
        <p class="productIntroduce">电子工程师的孵化巢</p>
      </div>
    </div>
    <div class="openBtnWrapper">
      <a>
        <div class="openBtn"> 打开 </div>
      </a>
      <WxOpenTag ref="wxopentag" :extinfo="openTarget" />
    </div>
  </div>
</template>

<script>
import utils from '@/utils/utils'
import WxOpenTag from '@/components/WxOpenTag'
export default {
  props: {
    openTarget: {
      type: String,
      required: true
    }
  },
  mounted(){
    if(utils.browserChecker.isWx()){
      this.$refs.wxopentag.register()
    }
  },
  components: {
    WxOpenTag
  }
}
</script>

<style lang="css" scoped>
.headerNav {
  z-index: 15;
  width: 100%;
  height: 56px;
  background-color: #ffffff;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  border-bottom: 2px solid rgba(0, 0, 0, 0.06);
}

.introduce {
  display: flex;
  align-items: center;
}

.logo {
  width: 35px;
}

.product {
  margin-top: -3px;
  padding-left: 7px;
  display: flex;
  flex-direction: column;
}

.productName{
  font-size: 14px;
  color: #1D2023;
  font-weight: 600;
}

.productIntroduce {
  font-size: 12px;
  color: #606972;
}

.openBtnWrapper{
  position: relative;
}
.openBtn {
  width: 60px;
  height: 23px;
  border-radius: 12px;
  background: linear-gradient(to right, #E50120, #FD4906);
  text-align: center;
  color: #fff;
  font-weight: 400;
  vertical-align: middle;
  line-height: 24px;
  font-size: 14px;
}
</style>
